import React from 'react';
import PropTypes from 'prop-types';
import APP_ICONS from './appIcons';

const SIZES = {
  xs: 24,
  sm: 28,
  md: 32,
  lg: 40,
  xl: 48,
};

const AppIcon = ({ name, size = 'md', className = '', style, alt = '' }) => {
  const src = APP_ICONS[name];
  if (!src) {
    return null;
  }

  const px = typeof size === 'number' ? size : SIZES[size] || SIZES.lg;

  return (
    <img
      src={src}
      alt={alt}
      className={`app-icon ${className}`.trim()}
      width={px}
      height={px}
      style={{ width: px, height: px, ...style }}
    />
  );
};

AppIcon.propTypes = {
  name: PropTypes.oneOf([
    'add',
    'edit',
    'delete',
    'info',
    'approve',
    'unapprove',
    'pdf',
    'graph',
    'back',
    'close',
    'image',
    'copy',
    'diagnosesNok',
    'save',
    'calendar',
  ]).isRequired,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    PropTypes.number,
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  alt: PropTypes.string,
};

export default AppIcon;
